import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, of } from "rxjs";

import { API_BASE_URL } from "../core/api-base-url";

@Injectable({ providedIn: "root" })
export class SecuredContentsService {
  private readonly baseUrl = API_BASE_URL;

  profilePhotoCache = new Map<string, Blob>();
  profilePhotoMissing: string[] = [];

  constructor(private http: HttpClient) {}

  public getProfilePhoto(key: string) {
    if (this.profilePhotoCache.has(key)) {
      return of(this.profilePhotoCache.get(key) ?? null);
    }

    if (this.profilePhotoMissing.includes(key)) {
      return of(null);
    }

    const resourceUrl = `${this.baseUrl}/contents/profilephoto/${key}`;

    return this.http.get(resourceUrl, { responseType: "blob" }).pipe(
      map((blob) => {
        if (blob) {
          this.profilePhotoCache.set(key, blob);
        } else if (!this.profilePhotoMissing.includes(key)) {
          this.profilePhotoMissing.push(key);
        }
        return blob;
      }),
    );
  }
}
